import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { Stack } from '@mui/material';

import { PoolButton } from '../button/pool-button';
import { PoolTypography } from '../typography/pool-typography';

export interface OverviewTableEmptyResultProps {
    emptyResultMessage?: ReactNode;
    emptyResultAction?: ReactNode;
    onReset?: () => void;
}

export const OverviewTableEmptyResult = (props: OverviewTableEmptyResultProps) => {
    const { emptyResultMessage, emptyResultAction } = props;
    return (
        <Stack gap={2} sx={{ my: 2, mx: theme => theme.general.pageContentSpacing, width: 'fit-content' }}>
            {emptyResultMessage ?? <PoolTypography id="app.common.emptyResult" />}
            <PoolButton styleType="firstLevel" color="primary" onClick={props.onReset}>
                {emptyResultAction ?? <FormattedMessage id="app.filter.reset" />}
            </PoolButton>
        </Stack>
    );
};
